import { Dropdown, MenuButton, Menu, MenuItem, ListDivider, RadioGroup, Radio } from '@mui/joy';
import SwapVertRoundedIcon from '@mui/icons-material/SwapVertRounded';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import { Button } from '@/ui/Button';

// Sort column picker plus a direction toggle. The caller supplies the columns
// it can sort by and which one to assume when no column is set yet.
export function SortMenu({ sort, setSort, columnOptions, defaultColumn, sx }) {
  const currentColumn = columnOptions.find((option) => option.value === sort.column);
  const isAscending = sort.direction === 'asc';
  const isUnset = !sort.column;

  return (
    <Dropdown>
      <Button
        component={MenuButton}
        size="xs"
        color="white"        
        startDecorator={isUnset ? <SwapVertRoundedIcon /> : isAscending ? <ArrowUpwardRoundedIcon /> : <ArrowDownwardRoundedIcon />}
        sx={{ sx }}        
      >
        {isUnset ? 'Sort' : currentColumn?.label}
      </Button>
      {/* Default popup z-index (1000) sits below Joy's modal z-index (1300), so
          this menu would render invisibly behind the modal when opened from
          inside one (e.g. the meal-plan add modal) without this override. */}
      <Menu placement="bottom-end" sx={{ minWidth: 220, zIndex: 'var(--joy-zIndex-snackbar, 1400)' }}>
        <RadioGroup
          value={sort.column || defaultColumn}
          onChange={(e) => {
            const column = e.target.value;
            const option = columnOptions.find((o) => o.value === column);
            setSort({ column, direction: option?.defaultDirection || 'desc' });
          }}
          sx={{ px: 1.5, py: 1 }}
        >
          {columnOptions.map((option) => (
            <Radio key={option.value} value={option.value} label={option.label} />
          ))}
        </RadioGroup>
        <ListDivider />
        <MenuItem onClick={() => setSort({
          column: sort.column || defaultColumn,
          direction: isAscending ? 'desc' : 'asc',
        })}>
          {isAscending ? <ArrowUpwardRoundedIcon /> : <ArrowDownwardRoundedIcon />}
          {isAscending ? 'Ascending' : 'Descending'}
        </MenuItem>
      </Menu>
    </Dropdown>
  );
}
